import { Observable } from 'rxjs';
import { StrictUnion } from '../../../../helpers/strict-union';
import { IconSize } from '../../icon/entities/icon-sizes.entity';
import { NavigationLink } from '../../navigation-item/entities/navigation-link.entity';

export enum ActionItemStyle {
    'Primary' = 'sh-button',
    'Secondary' = 'sh-button--secondary',
    'Ghost' = 'sh-button--ghost',
    'Inverted' = 'sh-button--inverted',
    'Light' = 'sh-button--light',
    'Link' = 'sh-link',
    'PureIconButton' = 'sh-pure-icon-button',
    'PureIconButtonInverted' = 'sh-pure-icon-button--inverted',
    'PureSquareIconButton' = 'sh-pure-square-icon-button',
    'PureSquareIconButtonInverted' = 'sh-pure-square-icon-button--inverted',
    'PureSquareIconButtonLight' = 'sh-pure-square-icon-button--light'
}

export enum ActionItemModifier {
    'ActionInInputField' = 'sh-input-field-with-action__action',
    'Small' = '-sh-small',
    'Large' = '-sh-large',
    'Round' = '-sh-round',
    'Condense' = '-sh-condense',
    'Raised' = '-sh-raised',
    'Invisible' = 'sh-invisible',
    'Bold' = '-sh-bold'
}

export enum ActionItemIconPosition {
    'Left' = 'left',
    'Right' = 'right'
}

export interface BaseActionItem {
    readonly label: string;
    readonly icon?: string;
    readonly iconSize?: IconSize;
    readonly iconPosition?: ActionItemIconPosition;
    readonly badgeLabel?: string;
    readonly style?: ActionItemStyle;
    readonly modifiers?: ActionItemModifier[];
    readonly disabled?: boolean;
    readonly disabledInfoMsg?: string;
    hidden?: boolean;
}

export interface LinkActionItem extends BaseActionItem {
    readonly navigationLink: NavigationLink;
}

export interface ButtonActionItem extends BaseActionItem {
    readonly eventListener: (event: MouseEvent) => void | Promise<any>;
    readonly type?: 'button' | 'submit' | 'reset';
}

export interface MultiActionItem extends BaseActionItem {
    readonly actionItems: ActionItem[];
    readonly openDirection?: OpenDirection;
    isOpen?: boolean;
}

export interface AsyncMultiActionItem extends BaseActionItem {
    readonly asyncActionItems: Observable<ActionItem | null>[];
    readonly openDirection?: OpenDirection;
    isOpen?: boolean;
}

export interface ApiActionBundle extends BaseActionItem {
    readonly apiActions$: Observable<ActionItem[]>;
}

export enum OpenDirection {
    'AboveLeft' = '-sh-open-above-push-left',
    'AboveRight' = '-sh-open-above-push-right',
    'BelowLeft' = '-sh-open-below-push-left',
    'BelowRight' = '-sh-open-below-push-right',
    'RightUp' = '-sh-open-right-push-up',
    'RightDown' = '-sh-open-right-push-down',
    'LeftUp' = '-sh-open-left-push-up',
    'LeftDown' = '-sh-open-left-push-down',
    'RightOverlap' = '-sh-open-right-overlap',
    'LeftOverlap' = '-sh-open-left-overlap'
}

export type ActionItem = StrictUnion<
    LinkActionItem | ButtonActionItem | MultiActionItem | AsyncMultiActionItem | ApiActionBundle
>;
